import type { Library } from '@/shared/helpers/api/types/entities.ts';

export const RECEIVER_STID = 'STID';

// STID fans this special scope out to all applicable facilities, so one message covers them all.
export const STID_GLOBAL_SCOPE = 'GLOBAL';

type LibraryScopeInfo = Pick<Library, 'isGlobal' | 'isVirtual'>;

/**
 * Mirrors `PublishFilterDataExtractor` on the server: a non-virtual global library published to
 * STID is sent once on the GLOBAL scope. Every other combination is published per selected
 * facility, so a facility selection is both required and what should be displayed.
 */
export function publishesToStidGlobalScope(
    library?: LibraryScopeInfo | null,
    applicationName?: string | null
): boolean {
    return !!library
        && !library.isVirtual
        && library.isGlobal
        && applicationName === RECEIVER_STID;
}
